<div class="element-2">
  <div class="section-41"></div>
  <div class="section-42">
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
      <div class="card-4">
        <div class="position-relative">
          <div class="row">
            <div class="col-12 d-flex justify-content-center align-items-center">
              <p class="log1">FMS</p>
            </div>
            <div class="col-12">
              <p class="log2">Financial Management Service</p>
              <h3 class="log-3 d-flex justify-content-center align-items-center mt-2">
                Forgot Password?
              </h3>
            </div>
          </div>
        </div>
        <div class="card-body mt-3">
          <form [formGroup]="LoginForm">
            <div class="row mt-1 mb-2">
              <div class="col-12">
                <input class="form-control form-control-3" placeholder="Username" type="text" autocomplete="off"
                  formControlName="Email" name="Email" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <input class="form-control form-control-3" style="border-color: #ced4da" placeholder="AgencyCode"
                  type="text" autocomplete="off" formControlName="agencycode" name="agencycode" />

              </div>
            </div>
            <div class="row mt-3">
              <div class="col mt-2 fogot-footer-2">
                <span class="f-21 d-flex flex-column">
                  <button class="btn btn_md" style="border-radius: 25px" (click)="forgotpasswordonboard()"
                    [disabled]="LoginForm.invalid">
                    Proceed
                  </button></span>
                <span class="f-22 d-flex flex-column">
                  <button class="btn btn_md" (click)="cancel()" style="border-radius: 25px">
                    Cancel
                  </button></span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>